import baseStyled, { ThemedStyledInterface, keyframes } from "styled-components";

export const theme = {
  color: {
    primary: "#1A2663",
    secondary: "#4B4B4B",
    header: "#FFFFFF",
    text: "#494949",
    lightText: "#B7B7B7",
    valid: "#0D9353",
    invalid: "#DD3E3E",
    highlightColor: "#F2631C",
  },
  mobileFirst: {
    breakPoint: "768px",
  },
};

export type Theme = typeof theme;
export const styled = baseStyled as ThemedStyledInterface<Theme>;
export type styledAnimation = typeof keyframes;

export type StyleSheet = { [key: string]: React.CSSProperties };
